import React from 'react';
import { pure } from 'recompose';
import MapGeoCollection from './MapGeoCollection';
import { Polyline, Placemark } from './MapGeoObjects';

const DEF_TRACK_OPACITY = 0.70;

const MapGroups = pure(({ objects, color, visible, opacity, strokeWidth, strokeStyle, media,
  hintContent, onClick, onMouseMove,
}) => (
  <MapGeoCollection>
    {Object.keys(objects).map(
      objectId => (
        <Polyline
          key={objectId}
          visible={visible}
          coords={objects[objectId].data}
          strokeWidth={strokeWidth}
          strokeColor={media && media.filename === objects[objectId].props.filename ? '#E03340' : color}
          strokeOpacity={opacity}
          strokeStyle={strokeStyle}
          hintContent={hintContent}
          onClick={event => (
            onClick && onClick(event, objects[objectId])
          )}
          onMouseEnter={event => (
            onMouseMove && onMouseMove(event, objects[objectId])
          )}
          onMouseMove={event => (
            onMouseMove && onMouseMove(event, objects[objectId])
          )}
        />
      ),
    )}
  </MapGeoCollection>
));

const MapTrack = ({
  track,
  withCaption,
  placemarkLocation,
  placemarkVisible,
  placemarkCaption,
  videoPlacemarkVisible,
  videoPlacemarkLocation,
  videoPlacemarkCaption,
  videoPlacemarkColor,
  opacity,
  visible,
  strokeWidth,
  trackColor,
  mediaColor,
  hintContent,
  media,
  onTrackClick,
  onMediaClick,
  onMouseMove,
  onPlacemarkMouseMove,
}) => (
  <MapGeoCollection>
    <MapGroups
      visible={visible}
      objects={track.coordsGroups}
      color={trackColor}
      opacity={0.25}
      strokeWidth={1}
      strokeStyle={'2 2'}
      hintContent={hintContent}
      onClick={onTrackClick}
      onMouseMove={onMouseMove}
    />
    <MapGroups
      visible={visible}
      objects={track.trackGroups}
      color={trackColor}
      opacity={DEF_TRACK_OPACITY * opacity}
      strokeWidth={strokeWidth}
      hintContent={hintContent}
      onClick={onTrackClick}
      onMouseMove={onMouseMove}
    />
    <MapGroups
      visible={visible}
      objects={track.mediaGroups}
      color={mediaColor}
      opacity={DEF_TRACK_OPACITY * opacity}
      strokeWidth={strokeWidth}
      hintContent={hintContent}
      media={videoPlacemarkVisible && media}
      onClick={onMediaClick}
      onMouseMove={onMouseMove}
    />
    <Placemark
      visible={placemarkVisible}
      coords={placemarkLocation}
      iconCaption={placemarkCaption}
      hintContent={hintContent}
      onMouseMove={onPlacemarkMouseMove}
      onClick={onTrackClick}
      preset={`islands#${videoPlacemarkColor}DotIcon${withCaption}`}
      iconCaptionMaxWidth="70"
    />
    <Placemark
      visible={videoPlacemarkVisible}
      coords={videoPlacemarkLocation}
      preset="islands#redDotIconWithCaption"
      iconCaption={videoPlacemarkCaption}
    />
  </MapGeoCollection>
);

export default pure(MapTrack);



// WEBPACK FOOTER //
// ./src/components/Map/MapTrack.jsx